<template>
    <div
        class="c-o-company-section c-o-company-section--certificates"
        id="certificates"
    >
        <div
            class="c-o-company-section__inner c-o-company-section__inner--centered c-o-company-section__inner--no-padding-bottom"
        >
            <div class="c-o-company-section__main">
                <h2 class="c-o-company-section__title h2">
                    Certifieringar & branschorganisationer
                </h2>
            </div>
        </div>

        <div
            class="c-o-company-section__inner c-o-company-section__inner--centered"
        >
            <div class="c-o-company-section__main">
                <div v-if="showSidebar" class="c-o-company-section__sidebar">
                    <div class="c-o-company-section__sidebar-block">
                        <div class="c-o-company-section__sidebar-content">
                            <ul class="c-o-company-section__sidebar-certs">
                                <li
                                    v-for="item in filteredCertificates"
                                    v-if="item.Proven"
                                    :key="
                                        `company-cert-id-${item.CompanyCertID}`
                                    "
                                    class="c-o-company-section__sidebar-cert"
                                >
                                    <div
                                        class="c-o-company-section__sidebar-cert-logo"
                                    >
                                        <img
                                            :src="imagePrefix + item.Image"
                                            alt="Bild på certifikat logotyp"
                                        />
                                    </div>
                                    <div
                                        class="c-o-company-section__sidebar-cert-info"
                                    >
                                        <p
                                            class="c-o-company-section__sidebar-cert-text"
                                            v-html="item.Description"
                                        ></p>
                                        <a
                                            class="c-o-company-section__sidebar-cert-link"
                                            target="_blank"
                                            :href="item.Link"
                                            >{{ item.LinkText }}</a
                                        >
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
 
<script>

export default {
    props: ["certificates"],
    computed: {
        showSidebar: function() {
            let proven = false;
            this.certificates.forEach(item => {
                if (item.Proven && item.CertID !== 30) {
                    proven = true;
                }
            });
            return this.certificates.length > 0 && proven;
        },
        filteredCertificates: function(){
            return this.certificates.filter(c => c.CertID !== 30)
        },
        imagePrefix: function() {
            return "https://static.brabyggare.se/certificates/";
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/company-sections/OrganismCompanySectionCertificates.vue